import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CommonField, FieldBase, TextboxField } from '../../../models/Field';

@Component({
  selector: 'textbox-1',
  template: `<div
    [formGroup]="form"
    class="form-group"
    [style.display]="isHidden ? 'none' : 'block'"
  >
    <label [attr.for]="fieldKey">{{ field.label }}</label>
    <div style="display: flex;">
      <ng-container *ngIf="prefixes">
        <div
        *ngFor="let prefix of prefixes"
        class="form-control"
        style="width: auto;"
        >{{ prefix }}</div>
      </ng-container>
      <input
        [formControlName]="field.key"
        (blur)="handleBlur($event)"
        class="form-control"
        [style.width]="field.size ? field.size + 'em' : ''"
        style="max-width: 100%;"
        [style.text-align]="field.textAlign"
        [disabled]="field.isLocked"
        type="text"
        id="{{ field.key }}"
        name="{{ field.key }}"
        placeholder="{{ field.placeholder }}"
      />
      <div
        *ngIf="field.usePercentageSuffix"
        class="form-control"
        style="width: auto;"
        >%</div>
    </div>
    <error-box [form]="form" [field]="field"></error-box>
  </div>`,
})
export class Textbox1Component implements OnInit {
  @Input() form: FormGroup;
  @Input() field: TextboxField;
  @Input() allFormFields: CommonField[];

  private prefixes: string[] = [];
  private subscriptions?: Subscription[] = [];

  get isHidden() {
    return this.field.isHidden;
  }

  get control() {
    return this.form.controls[this.field.key];
  }
  get errorKeys() {
    return Object.keys(this.control.errors);
  }

  handleBlur(evt) {
    if (this.field.formatOnBlur) {
      this.control.setValue(this.field.formatOnBlur(evt.target.value));
    }
  }

  calcPrefix(fKey) {
    const targetControl = this.form.controls[fKey]
    const targetValue = targetControl.value
    const targetField = this.allFormFields.find(f => f.key === fKey)
    if (targetField && targetField.items) {
      const targetItem = targetField.items.find(item => item.value == targetValue)
      return targetItem.label
    } else {
      return targetValue
    }
  }

  ngOnInit() {
    if (this.field.prefixFromFields) {
      this.field.prefixFromFields.forEach((fKey, i) => {
        this.prefixes[i] = this.calcPrefix(fKey)
        this.subscriptions.push(this.form.controls[fKey].valueChanges.subscribe(() => {
          this.prefixes[i] = this.calcPrefix(fKey)
        }))
      })
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => { s.unsubscribe() })
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/textbox/textbox-1.component.ts